'use strict'

/**
 * HSLColor
 * Workflow: lightweight value container for HSL components.
 */
class HSLColor {
    /**
     * @param {number} h Hue in degrees.
     * @param {number} s Saturation (0..1).
     * @param {number} l Lightness (0..1).
     */
    constructor(h = 0.0, s = 0.0, l = 0.0) {
        this.h = h
        this.s = s
        this.l = l
    }
}

export default HSLColor
